"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_document__rtf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7f5c754b-86c3-4c8d-bfa6-0bb0dba229fd",
    x1: 125.08,
    y1: 44.36,
    x2: 159.64,
    y2: 78.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "document-rtf-hi"), /*#__PURE__*/React.createElement("g", {
    id: "26ead12e-f033-4089-8ad2-f1da2ad2c9fd",
    "data-name": "document-rtf-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "88ff5af7-e39f-4bb5-9a1b-df9c6bd4b2ce",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d27ed0c2-2819-4e8a-9860-68fbcd8ec2a0",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5edccf62-d8b4-4653-85bd-ff9eea53a545",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7f1b65fd-3a4c-47e9-a46f-95d92a1b2211",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0805ce7f-7a30-47b6-8ab4-f43c3ae674f1",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7c93a496-7d9e-46a9-9fea-a36e42046a57",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16812703-a713-42c3-a7d4-669adab9bfd8",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f39b7f88-d006-4696-a356-223252499541",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ca9df2c5-ce21-4378-bdde-7e8bafa8e846",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ebfce82f-77a7-4920-85d7-b54475310de4",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9d48005b-0964-4ecd-81e2-83a0bac80d70",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b361bd2b-0fdc-484a-a3f5-3cc7cfecdc94",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "058628aa-36b4-4144-b4da-ae68e9687f8a",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "80d88c07-6e36-4881-960a-ff5804b3bbba",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bcb9b6a7-22d7-43cf-af12-90695d5f6b20",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4b793e34-954b-4a16-9ef0-10702be2d83a",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ef5c161a-5457-4e5d-aaf8-ef2d2b1d61bd",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7838f752-74fa-4db3-b683-29cfea9ac086",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8c24d95a-db57-4159-b77c-81119039bc20",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "66069ab3-d5fd-4d1b-b6fb-1d02fff68745",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3982fea7-5f8f-4bd4-bdb0-380c124b7742",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "966cb5b7-f2a6-4152-b16a-53989e34bd7e",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "78123c43-c483-4a20-8f05-37161e505ee1",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1144323d-f333-4e22-ac2b-875686003bd7",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f61cdc50-9104-42a2-8220-bd1c4fc49c40",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9aab5a10-aa35-47f4-b4f1-8dc3cc3e1570",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "157b41a2-4568-4559-8039-47d1decf8b1b",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2f31052f-abc2-4295-a6c0-39071241f881",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,44V160h0a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16h0V56H128a16,16,0,0,1-16-16V16H56A16,16,0,0,0,40,32V44",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,56H128a16,16,0,0,1-16-16V16Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,54a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h24l-2-2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,56c-.53,0-1.05,0-1.57-.08l-.62-.09c-.3,0-.6-.08-.89-.14s-.53-.12-.79-.19l-.65-.17c-.3-.09-.6-.2-.9-.3l-.47-.17c-.33-.13-.65-.28-1-.43l-.32-.16c-.35-.17-.68-.36-1-.56l-.2-.12q-.54-.33-1-.7l-.09-.07c-.36-.27-.71-.55-1-.84h0L152,86.56V56Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#7f5c754b-86c3-4c8d-bfa6-0bb0dba229fd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,174H56a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16v-2A16,16,0,0,1,136,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,125.58a2.73,2.73,0,0,1-2.3-1,3.45,3.45,0,0,1-.77-2.17,3.52,3.52,0,0,1,.77-2.21,2.73,2.73,0,0,1,2.3-1,2.67,2.67,0,0,1,2.28,1,3.59,3.59,0,0,1,.75,2.21,3.52,3.52,0,0,1-.75,2.17A2.67,2.67,0,0,1,57,125.58Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.84,125.1V95.87H75.05a12.84,12.84,0,0,1,5.35,1.05,7,7,0,0,1,3.4,3,9.51,9.51,0,0,1,1.07,4.58,8.6,8.6,0,0,1-1,4.12,8.25,8.25,0,0,1-3.11,3.16,4.23,4.23,0,0,1,2,1.62,13.28,13.28,0,0,1,1.47,3.68l2.19,8H80.58l-2.19-7.32a17.52,17.52,0,0,0-.92-2.37,2.1,2.1,0,0,0-1.12-1,4.64,4.64,0,0,0-1.73-.31H70.36v11Zm5.52-16h3.94q5,0,5-4A3.93,3.93,0,0,0,78.12,102a5.75,5.75,0,0,0-3.81-1H70.36Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.48,125.1V101.17H87.2v-5.3h22.18v5.3h-8.28V125.1Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.79,125.1V95.87h18.89v5.3H118.4v6.92H129v5.22H118.4V125.1Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })))))))))))))))))))))))))))))));
}

var _default = ic_document__rtf;
exports.default = _default;